var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Prompt',{attrs:{"activatorSize":"small","activatorIconSize":"small","activatorIcon":"fa-copy","inputText":"Nouveau nom pour la copie"},on:{"submit":function (v) { return _vm.copyRecipe(v); }}})}
var staticRenderFns = []

export { render, staticRenderFns }